import { useContext } from 'react';

import { EventBusContext } from 'dashboard/components/GraphModule/GraphCanvasContextProvider';

// In order for this hook to function, it must be preceded by a GraphContextWrapper
export function useEventBus() {
  const eventBus = useContext(EventBusContext);

  return eventBus;
}
